import middlewares from './middlewares'
import DatacenterCheckPage from '../views/Pages/DatacenterCheck/DatacenterCheckPage'
import PositionMonitoringPage from '../views/Pages/PositionMonitoring/PositionMonitoringPage'
import AccountPage from '../views/Pages/Account/AccountPage'
import AccountProfilePage from '../views/Pages/Account/Profile/ProfilePage'
import AccountPreferencesPage from '../views/Pages/Account/Preferences/PreferencesPage'
import AccountSubscriptionsPage from '../views/Pages/Account/SubscriptionsPage'
import AccountBillingPage from '../views/Pages/Account/BillingPage'
import AccountApiPage from '../views/Pages/Account/ApiPage'
import AdminUsersPage from '../views/Pages/Admin/AdminUsers/AdminUsersPage'
import AdminUserPage from '../views/Pages/Admin/AdminUser/AdminUserPage'
import AdminPage from '../views/Pages/Admin/AdminPage'
import LoginPage from '../views/Pages/LoginPage'
import ForgotPasswordPage from '../views/Pages/ForgotPasswordPage'
import VerifyPage from '../views/Pages/VerifyPage'
import AdminMultiProxyRouterPage from '../views/Pages/Admin/AdminMultiProxyRouterPage'
import AdminCrawlerConfigPage from '../views/Pages/Admin/AdminCrawlerConfigPage'
import UrlMonitoringPage from '@/views/Pages/UrlMonitoring/UrlMonitoringPage'

export default [
  {
    path: '',
    alias: '/',
    name: 'home', // Required for account module
    redirect: () => {
      return '/position-monitoring'
    }
  },
  {
    path: '/login/:token?',
    name: 'login', // Required for account module
    component: LoginPage,
    meta: {
      ui: {
        layout: 'minimal'
      }
    }
  },
  {
    path: '/forgot_password',
    name: 'forgot_password', // Required for account module
    component: ForgotPasswordPage,
    meta: {
      ui: {
        layout: 'minimal'
      }
    }
  },
  {
    path: '/verify',
    component: VerifyPage,
    name: 'verify', // Required for account module
    meta: {
      middlewares: [middlewares.authenticated],
      ui: {
        layout: 'minimal'
      }
    }
  },
  {
    path: '/url-monitoring',
    component: UrlMonitoringPage,
    meta: {
      middlewares: [middlewares.authenticated, middlewares.verified]
    }
  },
  {
    path: '/position-monitoring/:slug?',
    component: PositionMonitoringPage,
    meta: {
      middlewares: [middlewares.authenticated, middlewares.verified]
    }
  },
  {
    path: '/datacenter-check',
    component: DatacenterCheckPage,
    meta: {
      middlewares: [middlewares.authenticated, middlewares.verified]
    }
  },
  {
    path: '/account',
    component: AccountPage,
    children: [
      {
        path: 'profile',
        name: 'account_profile', // Required for account module
        component: AccountProfilePage,
        meta: {
          middlewares: [middlewares.authenticated, middlewares.verified]
        },
      },
      {
        path: 'preferences',
        component: AccountPreferencesPage,
        meta: {
          middlewares: [middlewares.authenticated, middlewares.verified]
        },
      },
      {
        path: 'subscriptions',
        component: AccountSubscriptionsPage,
        meta: {
          middlewares: [middlewares.authenticated, middlewares.verified]
        },
      },
      {
        path: 'billing',
        component: AccountBillingPage,
        meta: {
          middlewares: [middlewares.authenticated, middlewares.verified]
        },
      },
      {
        path: 'api',
        component: AccountApiPage,
        meta: {
          middlewares: [middlewares.authenticated, middlewares.verified]
        },
      },
    ]
  },
  {
    path: '/admin',
    component: AdminPage,
    meta: {
      middlewares: [middlewares.administrator]
    },
    children: [
      {
        path: 'users',
        component: AdminUsersPage,
        meta: {
          middlewares: [middlewares.administrator]
        },
      },
      {
        path: 'users/:id',
        component: AdminUserPage,
        meta: {
          middlewares: [middlewares.administrator]
        },
      },
      {
        path: 'multi-proxy/router',
        component: AdminMultiProxyRouterPage,
        meta: {
          middlewares: [middlewares.administrator]
        },
      },
      {
        path: 'crawler/config',
        component: AdminCrawlerConfigPage,
        meta: {
          middlewares: [middlewares.administrator]
        },
      }
    ]
  }
]